module.exports = __webpack_public_path__ + "img/Figure 5.627c9908.jpg";